import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { RideRequestType } from './ride-request-type';
import { VehicleType } from './vehicle-type';
import { Provider } from './provider';

@inheritSerialization(AbstractModel)
export class RideMonitoringAlert extends AbstractModel {
  @autoserialize
  operationAlertId: number;

  @autoserialize
  assigned: boolean;

  @autoserialize
  resolved: boolean;

  @autoserialize
  assigneeId: number;

  @autoserialize
  assigneeName: string;

  @autoserialize
  riderName: string;

  @autoserialize
  driverName: string;

  @autoserialize
  transitProgramCode: string;

  @autoserialize
  alertText: string;

  @autoserializeAs(Date)
  pickupDate: Date;

  @autoserialize
  timeZone: string;

  @autoserialize
  rideStatus: string;

  @autoserializeAs(Date)
  lastStatusUpdateDate: Date;

  @autoserialize
  reservationId: number;

  @autoserialize
  rideRequestId: number;

  @autoserialize
  riderPhoneNumber: string;

  @autoserializeAs(Date)
  operationsAlertCreatedDate: Date;

  @autoserializeAs(RideRequestType)
  rideRequestType: RideRequestType;

  @autoserialize
  isAmbulatory: boolean;

  @autoserialize
  providerName: string;

  @autoserialize
  resolvedByUserId: number;

  @autoserialize
  resolvedByUserName: string;

  @autoserializeAs(Date)
  resolvedAt: Date;

  static OnSerialized(instance: RideMonitoringAlert, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.pickupDate)) {
      json.pickupDate = DateUtil.serializeDate(instance.pickupDate);
    }

    if (!isNullOrUndefined(instance.lastStatusUpdateDate)) {
      json.lastStatusUpdateDate = DateUtil.serializeDate(instance.lastStatusUpdateDate);
    }

    if (!isNullOrUndefined(instance.operationsAlertCreatedDate)) {
      json.operationsAlertCreatedDate = DateUtil.serializeDate(instance.operationsAlertCreatedDate);
    }

    if (!isNullOrUndefined(instance.resolvedAt)) {
      json.resolvedAt = DateUtil.serializeDate(instance.resolvedAt);
    }
  }

  static OnDeserialized(instance: RideMonitoringAlert, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['pickupDate'])) {
      instance.pickupDate = DateUtil.deserializeDate(json['pickupDate']);
    }

    if (!isNullOrUndefined(json['lastStatusUpdateDate'])) {
      instance.lastStatusUpdateDate = DateUtil.deserializeDate(json['lastStatusUpdateDate']);
    }

    if (!isNullOrUndefined(json['operationsAlertCreatedDate'])) {
      instance.operationsAlertCreatedDate = DateUtil.deserializeDate(json['operationsAlertCreatedDate']);
    }

    if (!isNullOrUndefined(json['resolvedAt'])) {
      instance.resolvedAt = DateUtil.deserializeDate(json['resolvedAt']);
    }
  }
}
